import { mapModes } from 'client/utils/constants/appStates';
const { DEFAULT, DRAWING, MODIFYING, AOI, LOADING } = mapModes;

export const VALID_MODES = [
    [DEFAULT],
    [DEFAULT, DRAWING],
    [DEFAULT, LOADING],
    [DEFAULT, LOADING, AOI],
    [AOI, MODIFYING],
    [AOI, MODIFYING, DRAWING],
    [LOADING, DEFAULT],
    [LOADING, DEFAULT, AOI]
];
